import { FormlyFieldConfig } from '@ngx-formly/core';
import { FORMLY_FIELD_TYPES, FORMLY_FIELD_VALIDATORS, FORMLY_FIELD_WRAPPERS } from '@app/constants';

export const checkSignatureFields = (index: number, readOnly: boolean): FormlyFieldConfig => {
	return {
		fieldGroupClassName: '',
		fieldGroup: [
			{
				wrappers: [FORMLY_FIELD_WRAPPERS.matCardWrapper],
				props: {
					class: 'linq-card',
				},
				fieldGroup: [
					{
						type: FORMLY_FIELD_TYPES.headerLabel,
						props: {
							label: `Check Signature ${index}`,
							useElementH: '4',
							bold: false,
						},
					},
					{
						key: `Sig${index}ShowLine`,
						type: FORMLY_FIELD_TYPES.checkbox,
						props: {
							label: 'Signature Line Only',
							appearance: 'fill',
							indeterminate: false,
							disabled: readOnly,
						},
					},
					{
						key: `Signature${index}`,
						type: FORMLY_FIELD_TYPES.imagePreview,
						props: {
							isReadOnly: readOnly,
							bindToUrl: false,
							heightProp: 80,
						},
						expressions: {
							hide: (field: FormlyFieldConfig) => field.model[`Sig${index}ShowLine`],
						},
					},
					{
						key: `Sig${index}ShowTitle`,
						type: FORMLY_FIELD_TYPES.checkbox,
						props: {
							label: 'Include Signature Title',
							appearance: 'fill',
							indeterminate: false,
							disabled: readOnly,
						},
					},
					{
						key: `Sig${index}Title`,
						type: FORMLY_FIELD_TYPES.input,
						props: {
							label: 'Signature Title',
							placeholder: 'Enter Title to display below signature',
							maxLength: 50,
							required: true,
						},
						expressions: {
							'props.disabled': `${readOnly} || !model.Sig${index}ShowTitle`,
						},
						validators: {
							validation: [FORMLY_FIELD_VALIDATORS.hasBegEndWhitespace],
						},
					},
				],
			},
		],
	} as FormlyFieldConfig;
};
